const IconSearch = () => {
  return (
    <svg id="search" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path id="search-2" data-name="search" d="M20.68,18.217l-4.93-4.951a7.884,7.884,0,0,0,1.962-5.191A8.233,8.233,0,0,0,9.348,0,8.233,8.233,0,0,0,.984,8.075,8.233,8.233,0,0,0,9.348,16.15a8.48,8.48,0,0,0,4.792-1.461l4.968,4.988a1.119,1.119,0,0,0,1.542.029A1.029,1.029,0,0,0,20.68,18.217ZM9.348,2.107A6.085,6.085,0,0,1,15.53,8.075a6.085,6.085,0,0,1-6.182,5.968A6.085,6.085,0,0,1,3.166,8.075,6.085,6.085,0,0,1,9.348,2.107Z" transform="translate(-0.984)" fill="#95c515" />
    </svg>
  );
};

export default IconSearch;
